import React, { useEffect, useMemo, useRef, useState } from 'react'
import { flushSync } from 'react-dom'
import { useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import DatePicker from "react-datepicker"
import { Modal, Dropdown, DropdownButton } from 'react-bootstrap'

import ReactSelect from 'pages/parts/ReactSelect'
import usePreventExit from "pages/parts/usePreventExit"
import DocumentTemplate from 'pages/parts/DocumentTemplate'
import PhotoScanModal from 'pages/main/documentsIn/PhotoScanModal'
import { httpOk, GET, POST, PUT, DELETE, FILE } from 'helpers/api'
import { handleDecimalKeyDown } from 'helpers/decimalKey'
import { formatDate, formatMoney, returnMinDate, formatMoneyInput, notify } from 'helpers/helpers'
import { bestMatch, ELEMENT_MATCH_THRESHOLD, SUPPLIER_MATCH_THRESHOLD } from 'helpers/documentInPhoto'
import QuickSupplierModal from 'pages/main/suppliers/QuickSupplierModal'
import QuickElementModal from 'pages/main/elements/QuickElementModal'

// Окно задним числом — то же, что EDIT_WINDOW_DAYS в DocumentInController на бэкенде
const DOCUMENT_BACKDATE_DAYS = 30

function CreateUpdate() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	// Есть id в адресе — правим существующий документ, нет — создаём новый
	const { id } = useParams()

	const [isDirty, setIsDirty] = useState(false);
	const safeNavigate = usePreventExit(isDirty);

	const tbodyRef = useRef()
	const scrollRef = useRef()

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState({
		"items": [],
		"pos_id": reduxAccount.pos_id,
		"wms_id": reduxAccount.wms_id,
		"supplier_id": null,
		"total_amount": 0,
		"is_annul_negative": false,
		"created_at": formatDate(new Date(), 'yyyy-MM-dd'),
	})
	const [addQuantity, setAddQuantity] = useState(1)
	const [products, setProducts] = useState([])
	const [elements, setElements] = useState([])
	const [elementsDuplicate, setElementsDuplicate] = useState([])
	// ТАБЫ ПО ТИПАМ ПРОДУКТОВ
	const [productTypes, setProductTypes] = useState([])
	const [activeProductTypeId, setActiveProductTypeId] = useState(null) // null — «Все»
	// ТАБЫ ПО ТИПАМ ПРОДУКТОВ
	const [wms, setWms] = useState([])
	const [suppliers, setSuppliers] = useState([])
	const [problemElements, setProblemElements] = useState([])
	const [modalConfirm, setModalConfirm] = useState(false)
	const [negativeBalance, setNegativeBalance] = useState({ 'bool': false, 'items': [], 'is_draft': false })
	const [notFoundImportItems, setNotFoundImportItems] = useState([])
	const [modalNotFoundImport, setModalNotFoundImport] = useState(false)
	// TEMPLATE
	const [modalTemplate, setModalTemplate] = useState({ 'bool': false, 'templates': [] })
	const [modalTemplateCRUD, setModalTemplateCRUD] = useState({ 'bool': false, 'name': "", 'items': [] })
	// TEMPLATE
	// NEW ELEMENT
	const [modalElement, setModalElement] = useState(false)
	const [modalSupplier, setModalSupplier] = useState(false)
	const [quickElementRowIndex, setQuickElementRowIndex] = useState(null)
	const [modalWarning, setModalWarning] = useState(false)
	// NEW ELEMENT
	// ПРИХОД ПО ФОТО
	const [modalPhoto, setModalPhoto] = useState(false)
	// ПРИХОД ПО ФОТО

	// Черновиком можно сохранить новый документ или тот, что черновиком и был.
	// Проведённый документ обратно в черновик не уводим — это уже правка.
	const isDraftDocument = !data.id || Number(data.status) === 0

	async function createUpdate(stage = 1, asDraft = false, confirmNegative = false) {
		var dataCopy = { ...data }
		dataCopy.is_draft = asDraft
		dataCopy.confirm_negative = confirmNegative

		if (dataCopy.items.length === 0) {
			notify(t('add_elements'))
			return
		}

		for (let i = 0; i < dataCopy.items.length; i++) {
			// Строка с фото могла остаться без элемента — сохранять такую нечего
			if (!dataCopy.items[i]['element_id']) {
				dataCopy.error = true
				dataCopy.exist = i
			}
			if (!dataCopy.items[i]['quantity']) {
				dataCopy.error = true
				dataCopy.exist = i
			}
			if (dataCopy.items[i]['price'] === "" || dataCopy.items[i]['price'] < 0.0001) {
				dataCopy.error = true
				dataCopy.exist = i
			}
			// Ограничение склада: количество — numeric(12,4), т.е. не больше 99 999 999
			if (Number(dataCopy.items[i]['quantity']) > 99999999.9999) {
				notify(`Слишком большое количество: строка ${i + 1}`)
				return
			}
			if (Number(dataCopy.items[i]['price']) > 9999999999999.99) {
				notify(`Слишком большая цена: строка ${i + 1}`)
				return
			}
			var warningArray = []
			if (
				stage === 1 &&
				(Number(dataCopy.items[i]['price']) !== Number(dataCopy.items[i]['original_price']))
			) {
				warningArray.push(dataCopy.items[i])
				dataCopy.warning = true
			}

			if (warningArray.length) setProblemElements(warningArray)
		}

		if (dataCopy.exist >= 0) {
			notify(`Незаполненые поля: строка ${dataCopy.exist + 1}`)
			return
		}

		if (warningArray.length && stage === 1) {
			setModalWarning(true)
			return
		}

		if (stage === 1 || stage === 2) {
			setModalWarning(false)
			setModalConfirm(true)
			return
		}

		var response;
		// silent — ошибку показываем сами: уход остатка в минус это не отказ, а вопрос
		// к человеку, и вместо тоста на него отвечает модалка со списком товаров
		if (dataCopy.id) {
			response = await PUT('/documents-in', dataCopy, { loader: true, silent: true })
		} else {
			response = await POST('/documents-in', dataCopy, { loader: true, silent: true })
		}

		if (response?.status === 409 && response?.data?.error === 'negative_balance') {
			setModalConfirm(false)
			setNegativeBalance({ 'bool': true, 'items': response.data.items ?? [], 'is_draft': asDraft })
			return
		}

		if (!httpOk(response)) {
			notify(response?.data?.message || t('error'))
			return
		}

		if (httpOk(response)) {
			flushSync(() => setIsDirty(false))
			navigate('/documents-in')
		}
	}

	function addToList(length = 1) {
		var dataCopy = JSON.parse(JSON.stringify(data))

		for (let i = 0; i < length; i++) {
			dataCopy.items.push({
				'price': '',
				'element_id': '',
				'quantity': '',
				'unit_quantity': '',
			})
		}

		setIsDirty(true)
		countTotalAmount(dataCopy)

		setTimeout(() => {
			const byId = document.getElementById(`input-select-${dataCopy.items.length}`)
			byId?.select()
		}, 200);
	}

	function deleteItem(index) {
		var dataCopy = JSON.parse(JSON.stringify(data))
		dataCopy.items.splice(index, 1)

		countTotalAmount(dataCopy)
	}

	function countTotalAmount(dataCopy) {
		dataCopy.total_quantity = 0
		dataCopy.total_amount = 0
		for (let i = 0; i < dataCopy.items.length; i++) {
			dataCopy.total_quantity += Number(dataCopy.items[i]['quantity'])
			dataCopy.total_amount += Number(dataCopy.items[i]['quantity']) * Number(dataCopy.items[i]['price'])
			dataCopy.total_amount = Number(dataCopy.total_amount);
		}

		setData(dataCopy)
	}

	function handleInputChange(e, index) {
		var dataCopy = { ...data }

		dataCopy.items[index][e.target.name] = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '')
		if (e.target.name === "packaging_quantity") {
			dataCopy.items[index]["quantity"] = Number(dataCopy.items[index]["packaging_quantity"]) * Number(dataCopy.items[index]["unit_quantity"])
		}

		if (e.target.name === "packaging_quantity" && Number(dataCopy.items[index]["price"]) > 0) {
			dataCopy.items[index]["total_price"] =
				Math.round((Number(dataCopy.items[index]["quantity"]) * Number(dataCopy.items[index]["price"])) * 100) / 100;
		}
		if (e.target.name === "packaging_quantity" && !dataCopy.items[index]["price"]) {
			dataCopy.items[index]["total_price"] = 0
		}


		if (e.target.name === "price" && Number(dataCopy.items[index]["price"]) > 0) {
			dataCopy.items[index]["total_price"] =
				Number((Number(dataCopy.items[index]["quantity"]) * Number(dataCopy.items[index]["price"])));
		}

		if (e.target.name === "price" && !dataCopy.items[index]["price"]) {
			dataCopy.items[index]["total_price"] = 0
		}

		if (e.target.name === "total_price") {
			dataCopy.items[index]["total_price"] =
				Math.round(Number(dataCopy.items[index]["total_price"]) * 100) / 100;

			dataCopy.items[index]["price"] =
				Math.round((Number(dataCopy.items[index]["total_price"]) / Number(dataCopy.items[index]["quantity"])) * 100) / 100;
		}

		countTotalAmount(dataCopy)
	}

	// ТАБЫ ПО ТИПАМ ПРОДУКТОВ
	// Список для выпадашки = вся номенклатура, отфильтрованная активным табом и поиском
	function filterElements(items, productTypeId, search) {
		var filteredItems = [...items]

		if (productTypeId !== null) {
			filteredItems = filteredItems.filter(item =>
				Number(item.product_type_id) === Number(productTypeId))
		}

		if (search) {
			filteredItems = filteredItems.filter(item =>
				item.name.toLowerCase().includes(search.toLowerCase()))
			if (filteredItems[0]) {
				filteredItems[0]['selected'] = true
			}
		}

		return filteredItems
	}

	function handleSelectProductType(productTypeId) {
		setActiveProductTypeId(productTypeId)
		setElements(filterElements(elementsDuplicate, productTypeId, ''))
	}

	// Табы строим по типам, которые реально есть в загруженной номенклатуре,
	// название берём из справочника (переведённое), иначе — из самой номенклатуры
	const productTypeTabs = useMemo(() => {
		var tabs = []

		for (let i = 0; i < elementsDuplicate.length; i++) {
			const productTypeId = elementsDuplicate[i]['product_type_id']
			if (productTypeId === null || productTypeId === undefined) continue

			if (tabs.find(item => Number(item.id) === Number(productTypeId))) continue

			const productType = productTypes.find(item => Number(item.id) === Number(productTypeId))
			tabs.push({
				'id': productTypeId,
				'name': productType ? productType.name : elementsDuplicate[i]['product_type_name'],
			})
		}

		return tabs.sort((a, b) => Number(a.id) - Number(b.id))
	}, [elementsDuplicate, productTypes])
	// ТАБЫ ПО ТИПАМ ПРОДУКТОВ

	// REACTSELECT LOGIC
	function handleSelectSearch(value) {
		if (value === '+' || value === '=') return

		setElements(filterElements(elementsDuplicate, activeProductTypeId, value))
	}

	function handleSelectElement(option, index) {
		var dataCopy = { ...data }

		let exist = dataCopy.items.findIndex(item => item.element_id === option.product_id);
		if (exist !== -1) {
			notify(`Дубликат: строка ${exist + 1}`)
			return
		}

		// Позицию с фото сопоставляют руками уже после того, как количество и цену подставили,
		// поэтому при первом выборе элемента их не затираем справочными значениями
		const fromPhoto = !!dataCopy.items[index]['suggested_name'] && !dataCopy.items[index]['element_id']
		const enteredPrice = fromPhoto ? dataCopy.items[index]['price'] : ''
		const enteredQuantity = fromPhoto ? dataCopy.items[index]['quantity'] : ''
		const enteredPackagingQuantity = fromPhoto ? dataCopy.items[index]['packaging_quantity'] : ''
		const enteredTotalPrice = fromPhoto ? dataCopy.items[index]['total_price'] : ''

		dataCopy.items[index]['element_id'] = option.id
		dataCopy.items[index]['name'] = option.name
		dataCopy.items[index]['balance_id'] = option.balance_id
		dataCopy.items[index]['balance'] = option.balance
		dataCopy.items[index]['bool_loss'] = option.bool_loss
		if (option.price) {
			dataCopy.items[index]['initial_price'] = Number(option.price).toFixed(0)
			dataCopy.items[index]['price'] = Number(option.price).toFixed(0)
			dataCopy.items[index]['original_price'] = Number(option.original_price).toFixed(0)
		} else {
			dataCopy.items[index]['price'] = ""
			dataCopy.items[index]['original_price'] = 0
		}
		dataCopy.items[index]['unit_name'] = option.unit_name
		dataCopy.items[index]['second_unit_name'] = option.second_unit_name
		dataCopy.items[index]['loss_percentage'] = option.loss_percentage
		dataCopy.items[index]['units'] = option.units
		dataCopy.items[index]['total_price'] = ""
		dataCopy.items[index]['packaging_quantity'] = ""
		dataCopy.items[index]['unit_quantity'] = 1

		if (fromPhoto) {
			if (enteredPrice) dataCopy.items[index]['price'] = enteredPrice
			dataCopy.items[index]['quantity'] = enteredQuantity
			dataCopy.items[index]['packaging_quantity'] = enteredPackagingQuantity
			dataCopy.items[index]['total_price'] = enteredTotalPrice
			countTotalAmount(dataCopy)
			return
		}

		setData(dataCopy)
	}

	function closeReactSelect() {
		setTimeout(() => {
			var elementsCopy = [...elements]
			for (let i = 0; i < elementsCopy.length; i++) {
				elementsCopy[i]['selected'] = false
			}
			if (elementsCopy[0] && elementsCopy[0]['selected'])
				elementsCopy[0]['selected'] = true
			setElements(elementsCopy)
		}, 100);
	}

	function handleTableKeyDown(event) {
		event.stopPropagation();
		var currentIndex = elements.findIndex(el => el.selected);
		if (currentIndex >= 0) {
			var elementsCopy = [...elements]
			elementsCopy[currentIndex].selected = false
			switch (event.key) {
				case "ArrowUp":
					if (currentIndex === 0) {
						elementsCopy[elements.length - 1].selected = true
						currentIndex = elements.length - 1
					} else {
						elementsCopy[currentIndex - 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6) - 59.2
					break;
				case "ArrowDown":
					if (currentIndex === elements.length - 1) {
						elementsCopy[0].selected = true
						currentIndex = 0
					} else {
						elementsCopy[currentIndex + 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6)
					break;
				default: break;
			}

			setElements(elementsCopy)
		}
	}

	function handleSelectItemUnit(option, index) {
		var dataCopy = { ...data }

		dataCopy.items[index]['unit_id'] = option.id
		dataCopy.items[index]['packaging_id'] = option.id
		dataCopy.items[index]['unit_name'] = option.name
		dataCopy.items[index]['unit_quantity'] = option.quantity

		setData(dataCopy)
	}
	// REACTSELECT LOGIC

	// TEMPLATE LOGIC
	async function toggleModalTemplate(bool) {
		if (bool) {
			const response = await GET(`/documents-templates`, {}, { loader: true })
			if (httpOk(response)) {
				setModalTemplate({ ...modalTemplate, 'bool': bool, 'templates': response.data })
			}
		} else {
			setModalTemplate({ ...modalTemplate, 'bool': bool, 'templates': [] })
		}
	}

	async function toggleModalTemplateCRUD(bool) {
		if (bool) {
			const response = await GET(`/documents-templates-all-products`, {}, { loader: true })
			if (httpOk(response)) {
				setProducts(response.data)
				setModalTemplateCRUD({ ...modalTemplateCRUD, 'bool': bool, 'name': "", 'products': [] })
			}
		} else {
			setModalTemplateCRUD({ ...modalTemplateCRUD, 'bool': bool, 'name': "", 'products': [] })
		}
	}

	async function handleSelectTemplate(item) {
		var response = await GET(`/documents-templates-products/${item.id}`, {}, { loader: true })
		if (httpOk(response)) {
			response = response.data

			var items = []
			for (let i = 0; i < response.length; i++) {
				for (let j = 0; j < elementsDuplicate.length; j++) {
					if (response[i]['product_id'] === elementsDuplicate[j]['product_id']) {
						elementsDuplicate[j]['element_id'] = response[i]['product_id'] // изменить потом на product_id
						items.push(elementsDuplicate[j])
					}
				}
			}

			setData({ ...data, 'items': items })
			toggleModalTemplate(false)
		}
	}

	async function deleteTemplate(item) {
		const response = await DELETE(`/documents-templates/${item.id}`, {}, { loader: true })
		if (httpOk(response)) toggleModalTemplate(false)
	}
	// TEMPLATE LOGIC

	async function getWms(wmsId = reduxAccount.wms_id) {
		const responseSuppliers = await GET('/documents-in-suppliers', { 'pos_id': reduxAccount.pos_id }, { loader: true })
		if (httpOk(responseSuppliers)) setSuppliers(responseSuppliers.data)

		const responseWms = await GET(`/helper/wms?pos_id=${reduxAccount.pos_id}`, {}, { loader: true })
		if (httpOk(responseWms)) {
			setWms(responseWms.data)
			return await getElements(wmsId)
		}

		return []
	}

	// Правка существующего документа: тянем его состав и подставляем в ту же форму,
	// что и при создании. Номенклатуру грузим по складу документа, а не по складу
	// пользователя — иначе позиции чужого склада не нашли бы своих единиц и остатка.
	async function getDocumentForEdit(documentId) {
		const response = await GET(`/documents-in/${documentId}`, {}, { loader: true })
		if (!httpOk(response)) {
			navigate('/documents-in')
			return
		}

		const document = response.data
		if (!document.editable) {
			notify(t('document_edit_not_allowed'))
			navigate(`/documents-in/preview/${documentId}`)
			return
		}

		const elementsList = await getWms(document.wms_id)

		const items = (document.items ?? [])
			.filter(item => Number(item.status) !== -1)
			.map(item => {
				const element = elementsList.find(e => Number(e.product_id ?? e.id) === Number(item.element_id)) ?? {}
				const quantity = Number(item.quantity)
				const packagingQuantity = Number(item.packaging_quantity)

				return {
					...element,
					'element_id': item.element_id,
					'name': item.element_name,
					'quantity': quantity,
					'price': Number(item.price),
					'total_price': Number((quantity * Number(item.price)).toFixed(2)),
					'packaging_id': item.packaging_id,
					'packaging_quantity': item.packaging_quantity,
					// Количество в упаковке восстанавливаем из сохранённых чисел: в документе
					// лежит итог, а форма пересчитывает его из «упаковок × вложенность»
					'unit_quantity': packagingQuantity > 0 ? quantity / packagingQuantity : 1,
					'unit_name': item.unit_name,
					'original_price': element.original_price ?? Number(item.price),
					'initial_price': Number(item.price),
				}
			})

		setData(prev => ({
			...prev,
			'id': document.id,
			'status': document.status,
			'pos_id': document.pos_id,
			'wms_id': document.wms_id,
			'supplier_id': document.supplier_id,
			'note': document.note ?? '',
			'created_at': formatDate(document.created_at, 'yyyy-MM-dd'),
			'items': items,
			'total_amount': items.reduce((sum, item) => sum + (Number(item.quantity) * Number(item.price)), 0),
		}))
	}

	async function getProductTypes() {
		const response = await GET('/helper/product-types')
		if (httpOk(response)) setProductTypes(response.data)
	}

	async function getElements(wmsId) {
		// with_all_types — тянем номенклатуру всех типов, разделяем её табами
		const response = await GET(`/documents-in-elements?wms_id=${wmsId}&with_all_types=1`, {}, { loader: true })
		if (httpOk(response)) {
			setElements(filterElements(response.data, activeProductTypeId, ''))
			setElementsDuplicate(response.data)
			return response.data
		}

		return []
	}

	// Склад сменили — остатки и их id у уже набранных строк относятся к прежнему складу,
	// поэтому перетягиваем их из свежей номенклатуры (нет на новом складе — остаток 0)
	async function handleChangeWms(wmsId) {
		setData(prev => ({ ...prev, 'wms_id': wmsId }))

		const elementsList = await getElements(wmsId)

		setData(prev => ({
			...prev,
			'items': prev.items.map(item => {
				if (!item.element_id) return item

				const element = elementsList.find(e => Number(e.product_id ?? e.id) === Number(item.element_id))

				return {
					...item,
					'balance_id': element?.balance_id ?? null,
					'balance': element?.balance ?? 0,
				}
			}),
		}))
	}

	function handleCreatedElement(element) {
		if (!element) return

		const createdElement = {
			...element,
			product_id: element.product_id ?? element.id,
			// без типа элемент не пройдёт фильтр таба и будет виден только на «Все»
			product_type_id: element.product_type_id ?? 0,
			unit_quantity: 1,
			original_price: element.original_price ?? element.price,
			// базовая единица — без id, как её отдаёт список: id тут ждут из products_units (packaging_id)
			units: element.units ?? [{
				name: element.unit_name,
				quantity: 1,
			}],
		}
		const elementsDuplicateCopy = [...elementsDuplicate, createdElement]
		setElements(filterElements(elementsDuplicateCopy, activeProductTypeId, ''))
		setElementsDuplicate(elementsDuplicateCopy)

		if (quickElementRowIndex !== null && data.items[quickElementRowIndex]) {
			handleSelectElement(createdElement, quickElementRowIndex)
		}
	}

	function handleCreatedSupplier(supplier) {
		if (!supplier) return

		setSuppliers([...suppliers, supplier])
		setData({ ...data, supplier_id: supplier.id })
	}

	function toggleModalElement(bool, rowIndex = null) {
		setQuickElementRowIndex(rowIndex)
		setModalElement(bool)
	}
	// NEW ELEMENT LOGIC

	async function importFromExel(e) {
		if (!e.target.files?.[0]) return

		let formData = new FormData();
		formData.append("file", e.target.files[0]);

		var response = await FILE('/documents-in-excel-import', formData, { loader: true });
		if (httpOk(response)) {
			const importedRows = response?.data?.data || []
			const elementsMap = {}
			for (let i = 0; i < elementsDuplicate.length; i++) {
				elementsMap[elementsDuplicate[i].product_id] = elementsDuplicate[i]
			}

			const items = []
			const notFound = []
			for (let i = 0; i < importedRows.length; i++) {
				const row = importedRows[i]
				const element = elementsMap[row.product_id]
				if (!element) {
					notFound.push(row)
					continue
				}

				const rowData = row.row_data || {}
				const quantity = rowData.quantity ?? row.quantity ?? ""
				const price = rowData.price ?? row.price ?? ""

				items.push({
					...element,
					element_id: element.id,
					name: element.name,
					balance_id: element.balance_id,
					balance: element.balance,
					bool_loss: element.bool_loss,
					unit_name: element.unit_name,
					second_unit_name: element.second_unit_name,
					loss_percentage: element.loss_percentage,
					units: element.units || [],
					packaging_quantity: quantity ? String(quantity).replace(/,/g, '.').replace(/[^0-9.]/g, '') : "",
					quantity: quantity ? String(quantity).replace(/,/g, '.').replace(/[^0-9.]/g, '') : "",
					unit_quantity: 1,
					initial_price: price ? String(price).replace(/,/g, '.').replace(/[^0-9.]/g, '') : "",
					price: price ? String(price).replace(/,/g, '.').replace(/[^0-9.]/g, '') : "",
					original_price: price ? String(price).replace(/,/g, '.').replace(/[^0-9.]/g, '') : 0,
					total_price:
						(quantity && price)
							? Number(String(quantity).replace(/,/g, '.').replace(/[^0-9.]/g, '')) * Number(String(price).replace(/,/g, '.').replace(/[^0-9.]/g, ''))
							: "",
				})
			}

			const dataCopy = { ...data }
			dataCopy.items = items
			countTotalAmount(dataCopy)

			setNotFoundImportItems(notFound)
			if (notFound.length) setModalNotFoundImport(true)
		}

		document.getElementById('actual-btn-documents-in-import').value = '';
	}

	// ПРИХОД ПО ФОТО
	// Раскладываем распознанную накладную по форме: поставщик, дата, номер, позиции.
	// Что не совпало со справочником — остаётся строкой с подсказкой, элемент выбирает пользователь.
	function applyRecognized(recognized) {
		if (!recognized) return

		var dataCopy = { ...data }

		if (recognized.supplier_name && !dataCopy.supplier_id) {
			const supplier = bestMatch(recognized.supplier_name, suppliers, SUPPLIER_MATCH_THRESHOLD)
			if (supplier) dataCopy.supplier_id = supplier.id
		}

		// Датапикер в форме открыт только на последние DOCUMENT_BACKDATE_DAYS дней — дальше не уходим
		if (recognized.document_date) {
			const minDate = formatDate(returnMinDate(new Date(), DOCUMENT_BACKDATE_DAYS), 'yyyy-MM-dd')
			const maxDate = formatDate(new Date(), 'yyyy-MM-dd')
			if (recognized.document_date >= minDate && recognized.document_date <= maxDate) {
				dataCopy.created_at = recognized.document_date
			}
		}

		if (recognized.document_number && !dataCopy.note) {
			dataCopy.note = `№${recognized.document_number}`
		}

		const usedElementIds = []
		const items = []
		for (let i = 0; i < (recognized.items?.length ?? 0); i++) {
			const recognizedItem = recognized.items[i]
			const name = String(recognizedItem.name ?? '').trim()
			if (!name) continue

			const available = elementsDuplicate.filter(element => !usedElementIds.includes(element.id))
			const element = bestMatch(name, available, ELEMENT_MATCH_THRESHOLD)

			const quantity = Number(recognizedItem.quantity) > 0 ? Number(recognizedItem.quantity) : ''
			var price = Number(recognizedItem.price) > 0 ? Number(recognizedItem.price) : ''
			// Цена в накладной может стоять только суммой строки — тогда считаем её сами
			if (!price && quantity && Number(recognizedItem.amount) > 0) {
				price = Math.round((Number(recognizedItem.amount) / quantity) * 100) / 100
			}

			var item = {
				'suggested_name': name,
				'element_id': '',
				'quantity': quantity === '' ? '' : String(quantity),
				'packaging_quantity': quantity === '' ? '' : String(quantity),
				'unit_quantity': 1,
				'price': price === '' ? '' : String(price),
				'total_price': (quantity && price) ? Math.round(quantity * price * 100) / 100 : '',
			}

			if (element) {
				usedElementIds.push(element.id)
				item = {
					...element,
					...item,
					'element_id': element.id,
					'name': element.name,
					'units': element.units || [],
					'initial_price': element.price ? Number(element.price).toFixed(0) : '',
					'original_price': element.original_price ? Number(element.original_price).toFixed(0) : 0,
				}
			}

			items.push(item)
		}

		// Ненайденные — наверх, чтобы сразу было видно, что нужно доработать руками
		items.sort((a, b) => (a.element_id ? 1 : 0) - (b.element_id ? 1 : 0))

		dataCopy.items = items
		setIsDirty(true)
		countTotalAmount(dataCopy)
	}

	// Счётчики для баннера: сколько позиций пришло с фото и сколько из них не легло на справочник
	const photoItemsCount = useMemo(() =>
		data.items.filter(item => item.suggested_name).length, [data.items])
	const photoNotFoundCount = useMemo(() =>
		data.items.filter(item => item.suggested_name && !item.element_id).length, [data.items])
	// ПРИХОД ПО ФОТО

	useEffect(() => {
		getProductTypes()

		if (id) {
			getDocumentForEdit(id)
		} else {
			getWms()
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('good_reception')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{data.id ? t('edit') : t('create')}</h6>
					</div>
				</div>
				<div className="d-flex gap-2">
					{/* Отдельной кнопкой, а не пунктом меню — иначе про приход по фото никто не узнает */}
					<button type="button" className="btn btn-outline-primary btn-rounded"
						onClick={() => setModalPhoto(true)}>
						<i className="uil uil-camera me-1"></i>
						{t('reception_by_photo')}
					</button>
					<DropdownButton title={t('action')}>
						<Dropdown.Item as="li">
							<input
								id="actual-btn-documents-in-import"
								hidden
								type="file"
								onChange={importFromExel}
								accept=".xlsx, application/vnd.ms-excel"
							/>
							<label htmlFor="actual-btn-documents-in-import" className="upload-from-excel">
								{t('import')}
							</label>
						</Dropdown.Item>
						<Dropdown.Item as="li">
							<a href={`${process.env.REACT_APP_DOWNLOAD_DOMAIN}/files/document_in_template.xlsx`} className="upload-from-excel">
								{t('download_template')}
							</a>
						</Dropdown.Item>
						<hr className="m-0" />
						<Dropdown.Item onClick={() => toggleModalTemplate(true)}>
							{t('templates')}
						</Dropdown.Item>
						<Dropdown.Item onClick={() => toggleModalTemplateCRUD(true)}>
							{t('create_template')}
						</Dropdown.Item>
					</DropdownButton>
				</div>
			</div>

			<form autoComplete="off">
				<div className="card mb-3">
					<div className="card-body">
						<div className="row">
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('date')}<span className="required-mark">*</span></label>
									<div className="calendar-input">
										<DatePicker
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
											yearDropdownItemNumber={2}
											className="form-control"
											dateFormat="dd.MM.yyyy"
											selected={data.created_at ? new Date(data.created_at) : ''}
											onChange={(date) => setData({ ...data, 'created_at': formatDate(date, 'yyyy-MM-dd') })}
											minDate={returnMinDate(new Date(), DOCUMENT_BACKDATE_DAYS)}
											maxDate={new Date()} />
										<i className="uil uil-calendar-alt"></i>
									</div>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('wms')}<span className="required-mark">*</span></label>
									<Select
										options={wms}
										value={wms.find(option => option.id === data.wms_id)}
										onChange={(option) => handleChangeWms(option.id)}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<div className="d-flex justify-content-between">
										<label>{t('supplier')}<span className="required-mark">*</span></label>
										<div className="table-action-button table-action-primary-button"
											onClick={() => setModalSupplier(true)}>
											<i className="uil-plus"></i>
										</div>
									</div>
									<Select
										options={suppliers}
										value={suppliers.find(option => option.id === data.supplier_id)}
										onChange={(option) => setData({ ...data, 'supplier_id': option.id })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('note')}</label>
									<input type="text" className="form-control"
										name="note"
										value={data.note ?? ''}
										onChange={(e) => setData({ ...data, 'note': e.target.value })} />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="card">
					<div className="card-body">
						{/* PRODUCT TYPE TABS */}
						<ul className="nav nav-tabs nav-tabs-compact mb-2">
							<li className="nav-item cursor"
								onClick={() => handleSelectProductType(null)}>
								<span className={`nav-link ${activeProductTypeId === null ? 'active ' : ''}`}>
									{t('all')}
								</span>
							</li>
							{productTypeTabs.map((item, index) => (
								<li className="nav-item cursor" key={index}
									onClick={() => handleSelectProductType(item.id)}>
									<span className={`nav-link ${Number(activeProductTypeId) === Number(item.id) && activeProductTypeId !== null ? 'active ' : ''}`}>
										{item.name}
									</span>
								</li>
							))}
						</ul>
						{/* PRODUCT TYPE TABS */}

						{photoNotFoundCount > 0 &&
							<div className="alert alert-warning">
								<div className="fw-600">
									{photoNotFoundCount} / {photoItemsCount} {t('positions_not_found')}
								</div>
								<div>{t('positions_not_found_hint')}</div>
							</div>
						}

						<table className="table table-bordered" style={{ 'overflow': 'unset' }}>
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '30%' }}>
										<div className="d-flex justify-content-between align-items-center">
											<span>{t('name2')}</span>
											<div className="table-action-button table-action-primary-button"
												onClick={() => toggleModalElement(true)}>
												<i className="uil-plus"></i>
											</div>
										</div>
									</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('balance2')}</th>
									<th style={{ 'width': '10%' }} className="text-start">{t('unit')}</th>
									<th style={{ 'width': '10%' }} className="text-end">
										{t('quantity')}<span className="required-mark">*</span>
									</th>
									<th style={{ 'width': '10%' }} className="text-end">
										{t('fact')}
									</th>
									<th style={{ 'width': '10%' }} className="text-end">
										{t('price')}<span className="required-mark">*</span>
									</th>
									<th style={{ 'width': '20%' }} className="text-end">{t('amount')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.items?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>
											<ReactSelect
												uniqueId="select"
												search={handleSelectSearch}
												value={item.name}
												index={index}
												scrollRef={scrollRef}
												options={elements}
												onClose={() => closeReactSelect()}
												selectItem={(option) => handleSelectElement(option, index)}
												onKeyUp={(e) => {
													if (e.keyCode === 40 || e.keyCode === 38) {
														handleTableKeyDown(e)
													}
												}}
												table={
													<table className="table mb-0">
														<tbody ref={tbodyRef}>
															{elements.map((selectItem, selectIndex) => (
																<tr
																	id={selectItem.id}
																	className={`cursor ${((selectItem.selected || selectItem.id === item.element_id) && 'selected')}`}
																	tabIndex={-1}
																	key={selectIndex}
																	onClick={() => handleSelectElement(selectItem, index)}
																	onKeyDown={(e) => handleTableKeyDown(e, selectItem, index)}>
																	<td>{selectItem.name}</td>
																	<td>{selectItem.product_type_name}</td>
																	<td className="text-end text-nowrap">{formatMoney(selectItem.price)}</td>
																</tr>
															))}
														</tbody>
													</table>
												}
											/>
											{/* Наименование с фото — видно, пока позицию не сопоставили со справочником */}
											{item.suggested_name &&
												<small className={item.element_id ? 'text-muted' : 'text-danger'}>
													{item.element_id ? t('from_photo') : t('not_found_in_handbook')}: {item.suggested_name}
												</small>
											}
										</td>
										<td className="text-end text-nowrap vertical-middle">
											{formatMoney(item.balance, 4)}
										</td>
										<td>
											<ReactSelect
												tabIndex={-1}
												uniqueId="select2"
												search={handleSelectSearch}
												value={item.unit_name}
												index={index}
												scrollRef={scrollRef}
												options={item.units}
												onClose={() => closeReactSelect()}
												selectItem={(option) => handleSelectItemUnit(option, index)}
												onKeyUp={(e) => {
													if (e.keyCode === 40 || e.keyCode === 38) {
														handleTableKeyDown(e)
													}
												}}
												table={
													<table className="table mb-0">
														<tbody ref={tbodyRef}>
															{item?.units?.map((selectItem, selectIndex) => (
																<tr
																	id={selectItem.id}
																	className={`cursor ${((selectItem.selected || selectItem.id === item.unit_id) && 'selected')}`}
																	tabIndex={-1}
																	key={selectIndex}
																	onClick={() => handleSelectItemUnit(selectItem, index)}
																	onKeyDown={(e) => handleTableKeyDown(e, selectItem, index)}>
																	<td>{selectItem.name}</td>
																</tr>
															))}
														</tbody>
													</table>
												}
											/>
										</td>
										<td className="td-input" style={!item.packaging_quantity ? { 'borderBottom': '2px solid red' } : {}}>
											<input
												type="text"
												name="packaging_quantity"
												className="form-control text-end"
												placeholder="0"
												value={formatMoneyInput(item.packaging_quantity) ?? ''}
												onChange={(e) => handleInputChange(e, index)}
												onKeyDown={(e) => handleDecimalKeyDown(e, (event) => handleInputChange(event, index))} />
										</td>
										<td className="text-end">{item.quantity}</td>
										<td className="td-input" style={!item.price ? { 'borderBottom': '2px solid red' } : {}}>
											<input
												type="text"
												name="price"
												placeholder="0"
												className="form-control text-end"
												value={item.price ?? ''}
												onChange={(e) => handleInputChange(e, index)}
												onKeyDown={(e) => handleDecimalKeyDown(e, (event) => handleInputChange(event, index))}
											/>
										</td>
										<td className="td-input" style={!item.total_price ? { 'borderBottom': '2px solid red' } : {}}>
											<input
												type="text"
												name="total_price"
												placeholder="0"
												className="form-control text-end"
												value={item.total_price ?? ''}
												onChange={(e) => handleInputChange(e, index)}
												onKeyDown={(e) => handleDecimalKeyDown(e, (event) => handleInputChange(event, index))}
												onKeyUp={(event) => {
													if (event.key === 'Enter') {
														addToList()
													}
												}}
											/>
										</td>
										<td className="vertical-middle">
											<div className="d-flex justify-content-end">
												<div className="table-action-button table-action-danger-button"
													onClick={() => deleteItem(index)}>
													<i className="uil uil-times"></i>
												</div>
											</div>
										</td>
									</tr>
								))}
								<tr>
									<td className="td-input">
										<input
											type="text"
											className="form-control text-center"
											style={{ 'padding': '5px 0' }}
											placeholder="xxx"
											value={addQuantity}
											onChange={(e) => setAddQuantity(e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, ''))}
										/>
									</td>
									<td colSpan={1} style={{ 'padding': 0 }}>
										<div className="d-flex">
											<div className="w-100">
												<button type="button" className="btn-sm btn-primary w-100"
													disabled={!data.wms_id}
													onClick={() => {
														setAddQuantity(1)
														addToList(addQuantity)
													}}>
													{t('add')}
												</button>
											</div>
										</div>
									</td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-end">
										{formatMoney(data.total_quantity, 2)}
									</td>
									<td></td>
									<td className="text-end">
										{formatMoney(data.total_amount)}
									</td>
									<td></td>
								</tr>
							</tbody>
						</table>

						<div className="annul-negative form-check">
							<input type="checkbox" className="form-check-input"
								id="isAnnulNegative"
								name="is_annul_negative"
								checked={data?.is_annul_negative ? true : false}
								onChange={(e) => setData({ ...data, 'is_annul_negative': e.target.checked })}
							/>
							<label className="form-check-label annul-negative-text" htmlFor="isAnnulNegative">
								<span className="annul-negative-title">{t('annual_negative_values')}</span>
								<span className="annul-negative-hint">{t('annual_negative_values_hint')}</span>
							</label>
						</div>

						<div className="btn-wrapper gap-2">
							<button type="button" className="btn btn-warning btn-rounded btn-wide" tabIndex="-1"
								onClick={() => safeNavigate('/documents-in')}>
								{t('cancel')}
							</button>
							{/* Черновик ничего не двигает: ни остаток, ни долг. Его можно оставить
								недоделанным и провести позже кнопкой «Подтвердить» */}
							{isDraftDocument &&
								<button type="button" className="btn btn-outline-primary btn-rounded btn-wide" tabIndex="-1"
									onClick={() => createUpdate(3, true)}>
									{t('save_draft')}
								</button>
							}
							<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
								onClick={() => createUpdate(1)}>
								{t('confirm')}
							</button>
						</div>
					</div>
				</div>
			</form>

			{/* MODAL WARNING */}
			<Modal show={modalWarning} animation={false} centered size="md"
				onHide={() => setModalWarning(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('warning')}!</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '45%' }}>{t('name2')}</th>
									<th style={{ 'width': '15%' }}>{t('unit')}</th>
									<th className="text-end" style={{ 'width': '20%' }}>{t('before')}</th>
									<th className="text-end" style={{ 'width': '20%' }}>{t('after')}</th>
								</tr>
							</thead>
							<tbody>
								{problemElements?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.name}</td>
										<td>{item.unit_name}</td>
										<td className="text-end">{formatMoney(item.original_price, 2)}</td>
										<td className="text-end">{formatMoney(item.price, 2)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<div className="btn-wrapper gap-2">
						<button type="button" className="btn btn-warning btn-rounded btn-wide" tabIndex="-1"
							onClick={() => setModalWarning(false)}>
							{t('cancel')}
						</button>
						<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
							onClick={() => createUpdate(2)}>
							{t('continue')}
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL WARNING */}

			{/* MODAL CONFIRM */}
			<Modal show={modalConfirm} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => setModalConfirm(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('confirm')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{/* Правка проведённого документа переписывает остатки и долг задним числом —
						без причины в журнале потом не разобрать, почему цифры изменились */}
					{!!data.id &&
						<div className="form-group">
							<label>{t('reason')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control"
								value={data.comment ?? ''}
								autoFocus
								onChange={(e) => setData({ ...data, 'comment': e.target.value })} />
						</div>
					}
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => setModalConfirm(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							disabled={!!data.id && !data.comment?.trim()}
							onClick={() => createUpdate(3)}>
							{t('confirm')}
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL CONFIRM */}

			{/* MODAL NEGATIVE BALANCE */}
			<Modal show={negativeBalance.bool} animation={false} centered size="md"
				onHide={() => setNegativeBalance({ ...negativeBalance, 'bool': false })}>
				<Modal.Header closeButton>
					<Modal.Title>{t('warning')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="mb-2">{t('negative_balance_after_edit')}</div>

					<div className="table-responsive mb-3">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '60%' }}>{t('name2')}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t('balance')}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t('after')}</th>
								</tr>
							</thead>
							<tbody>
								{negativeBalance.items.map((item, index) => (
									<tr key={index}>
										<td className="td-ellipsis">{item.name}</td>
										<td className="text-end">{formatMoney(item.balance, 2)}</td>
										<td className="text-end text-danger">{formatMoney(item.forecast, 2)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => setNegativeBalance({ ...negativeBalance, 'bool': false })}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							onClick={() => {
								setNegativeBalance({ ...negativeBalance, 'bool': false })
								createUpdate(3, negativeBalance.is_draft, true)
							}}>
							{t('confirm')}
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL NEGATIVE BALANCE */}

			<QuickElementModal
				show={modalElement}
				defaultValues={{ wms_id: data.wms_id }}
				onClose={() => toggleModalElement(false)}
				onCreated={handleCreatedElement}>
			</QuickElementModal>

			<QuickSupplierModal
				show={modalSupplier}
				onClose={() => setModalSupplier(false)}
				onCreated={handleCreatedSupplier}>
			</QuickSupplierModal>

			<PhotoScanModal
				show={modalPhoto}
				posId={reduxAccount.pos_id}
				onClose={() => setModalPhoto(false)}
				onApply={applyRecognized}>
			</PhotoScanModal>

			{/* MODAL TEMPLATE */}
			<Modal show={modalTemplate.bool} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => toggleModalTemplate(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('templates')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered table-hover cursor mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '100%' }}>{t('name2')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{modalTemplate?.templates?.map((item, index) => (
									<tr key={index}>
										<td className="text-center" style={{ 'minWidth': '33px' }}>{index + 1}</td>
										<td className="w-100"
											onClick={() => handleSelectTemplate(item)}>
											{item.name}
										</td>
										<td className="text-center" style={{ 'minWidth': '33px' }}>
											<div className="d-flex justify-content-end">
												<div className="table-action-button table-action-danger-button"
													onClick={() => deleteTemplate(item)}>
													<i className="uil uil-times"></i>
												</div>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL TEMPLATE */}

			{/* MODAL TEMPLATE */}
			{modalTemplateCRUD.bool &&
				<DocumentTemplate
					products={products}
					modalTemplateCRUD={modalTemplateCRUD}
					setModalTemplateCRUD={setModalTemplateCRUD}
					toggleModalTemplateCRUD={toggleModalTemplateCRUD}>
				</DocumentTemplate>
			}
			{/* MODAL TEMPLATE */}

			{/* MODAL NOT FOUND IMPORT ITEMS */}
			<Modal show={modalNotFoundImport} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setModalNotFoundImport(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('not_found')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'minWidth': '80px' }} className="text-center">{t('row')}</th>
									<th style={{ 'width': '100%' }}>{t('name2')}</th>
									<th style={{ 'minWidth': '100px' }} className="text-end">{t('quantity')}</th>
									<th style={{ 'minWidth': '120px' }} className="text-end">{t('price')}</th>
								</tr>
							</thead>
							<tbody>
								{notFoundImportItems.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="text-center">{item.row}</td>
										<td className="td-ellipsis">{item.name}</td>
										<td className="text-end">{item.quantity ?? ''}</td>
										<td className="text-end">{item.price ?? ''}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL NOT FOUND IMPORT ITEMS */}
		</>
	)
}

export default CreateUpdate